import Axios from './axios_wrapper'

// Used for add patient checkboxes
export function getQuestionnaires() {
  return Axios({
    url: `/questionnaires`,
    method: 'GET'
  })
}

export function getOneWeekQuestionnaires() {
  return Axios({
    url: `/questionnaires/timepoints/one_week`,
    method: 'GET'
  })
}

export function getOneMonthQuestionnaires() {
  return Axios({
    url: `/questionnaires/timepoints/one_month`,
    method: 'GET'
  })
}

export function getQuestionnairesForSurgeon(surgeon_id) {
  return Axios({
    url: `/surgeons/${surgeon_id}/questionnaires`,
    method: 'GET'
  })
}

export function getValidQuestionnairesForSurgeon(surgeon_id) {
  return Axios({
    url: `/surgeons/${surgeon_id}/valid_questionnaires`,
    method: 'GET'
  })
}

export function setQuestionnairesForSurgeon(surgeon_id, data) {
  return Axios({
    url: `/surgeons/${surgeon_id}/questionnaires`,
    method: 'POST',
    data
  })
}

export function getPreopForSurgeon(surgeon_id) {
  return Axios({
    url: `/surgeons/${surgeon_id}/preopquestionnaire`,
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/questionnaire.js
// module id = null
// module chunks = 